import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IvrDatasourceService } from '../../data/ivr-datasource.service';

@Component({
  selector: 'rmi-edit-report-button-by-admin',
  templateUrl: './edit-report-button-by-admin.component.html',
  styleUrls: ['./edit-report-button-by-admin.component.scss'],
})
export class EditReportButtonByAdminComponent implements OnInit, OnDestroy {
  @Output() openRelatedEditModal: EventEmitter<void> = new EventEmitter();
  private readonly destroy$ = new Subject<void>();

  show = false;

  constructor(private ivrDataSource: IvrDatasourceService) {}

  ngOnInit(): void {
    this.ivrDataSource.showEditReportButtons$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (showEditReportButton: boolean) => (this.show = showEditReportButton)
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
